export const normalizePublishDate = (posts: { data: BlogResource }[]) =>
  posts.map(post => ({
    ...post,
    data: {
      ...post.data,
      publishDate: post?.data?.publishDate || post?.data?.publishedDate || '',
    },
  }));
